import { render, staticRenderFns } from "./product_phone_bill_url.vue?vue&type=template&id=0b9ea3a5&scoped=true"
import script from "./product_phone_bill_url.vue?vue&type=script&lang=js"
export * from "./product_phone_bill_url.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ea3a5",
  null
  
)

export default component.exports